import { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'

import * as UI from '@/components/componentLibrary'
import { SpatialPolicy as Policy } from '@/models/spatialPolicy'
import { isEmpty } from '@/modules/map/utils'

import { HideableField } from '../components'
import { EditableFieldProps } from '../types'

import './index.scss'

const MINIMUM_TITLE = 'Minimum'

export const Minimum = ({ policy, ...props }: { policy: Policy }) => {
  const { t } = useTranslation()

  return (
    <HideableField
      hidden={!policy.minimum && policy.minimum !== 0}
      titleText={t('policiesLibrary.formMinimumTitle', MINIMUM_TITLE)}
      {...props}
    >
      <UI.Input
        className="policies-table-form-minimum"
        editable={false}
        name="minimum"
        value={isEmpty(policy.minimum) ? '' : policy.minimum}
      />
    </HideableField>
  )
}

export const EditableMinimum = ({
  editable,
  editPolicy,
  onValidate,
  policy,
  ...props
}: EditableFieldProps) => {
  const { t } = useTranslation()

  return editable ? (
    <HideableField
      editable
      titleText={t('policiesLibrary.formMinimumTitle', MINIMUM_TITLE)}
      {...props}
    >
      <UI.Input
        className="policies-table-form-minimum"
        editable
        error={props.error}
        name="minimum"
        type="number"
        onBlur={onValidate}
        onChange={(e: ChangeEvent<HTMLInputElement>) => {
          const { value } = e.target
          if (isEmpty(value)) editPolicy?.(p => p.setMinimum(null))
          else {
            const parsed = Number.parseInt(value, 10)
            editPolicy?.(p => p.setMinimum(Number.isNaN(parsed) ? null : parsed))
          }
        }}
        placeholder="00"
        value={isEmpty(policy.minimum) ? '' : policy.minimum}
      />
    </HideableField>
  ) : (
    <Minimum policy={policy} {...props} />
  )
}
